import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

export default function MultipleSelectChip(props) {
    const { handleChange, persons, names } = props
    const theme = useTheme();

    return (
        <FormControl sx={{ width: '100%', display: 'flex', mb: '10px' }}>
            <InputLabel id="demo-multiple-chip-label">{props.label}</InputLabel>
            <Select
                labelId="demo-multiple-chip-label"
                id="demo-multiple-chip"
                multiple
                value={persons}
                onChange={handleChange}
                input={<OutlinedInput id="select-multiple-chip" label={props.label} />}
                renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((targetId) => {
                        const person = names.find(item => item._id === targetId);
                        if (person) {
                        return (
                            <Chip key={person._id} label={person.personnel_first_name + ' ' + person.personnel_last_name + (!person?.email_verification_status ? " (pending)": "")} />
                        );
                        }
                        return null; // If person is not found, return null
                    })}
                    </Box>
                )}
                MenuProps={MenuProps}
            >
                {names.map((name, index) => (
                    <MenuItem
                        key={index}
                        value={name._id}
                        style={getStyles(name.personnel_first_name + ' ' + name.personnel_last_name, persons, theme)}
                    >
                        <Checkbox checked={persons.indexOf(name._id) > -1} />
                        <ListItemText primary={name.personnel_first_name + ' ' + name.personnel_last_name + (!name?.email_verification_status ? " (pending)": "")} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>

    );
}